import Glide from '@glidejs/glide';
import { getElements, ifSelectorExist } from './utils';

export const clixsySliders = () => {
  const grSlider = '.lsa_reviews_slider';
  if (ifSelectorExist(grSlider)) {
    Array.from(getElements(grSlider)).forEach(item => {
      new Glide(item, {
        perView: 2,
        type: 'carousel',
        breakpoints: {
          1024: {
            perView: 1,
          },
        },
      }).mount();
    });
  }

  const caseResultsSlider = '.attorneys-case-results-block__slider';
  if (ifSelectorExist(caseResultsSlider)) {
    Array.from(getElements(caseResultsSlider)).forEach(item => {
      new Glide(item, {
        perView: 4,
        type: 'carousel',
        gap: 25,
        breakpoints: {
          1280: {
            perView: 3,
          },
          900: {
            perView: 1.5,
          },
          640: {
            perView: 1,
            gap: 10,
          },
        },
      }).mount();
    });
  }

  const attorneysTabsBlockVideosSlider = '.attorneys-tabs-block__videos_slider';
  if (ifSelectorExist(attorneysTabsBlockVideosSlider)) {
    Array.from(getElements(attorneysTabsBlockVideosSlider)).forEach(item => {
      new Glide(item, {
        perView: 1,
        type: 'carousel',
      }).mount();
    });
  }

  const attorneysTabsBlockImagesSlider = '.attorneys-tabs-block__images_slider';
  if (ifSelectorExist(attorneysTabsBlockImagesSlider)) {
    Array.from(getElements(attorneysTabsBlockImagesSlider)).forEach(item => {
      new Glide(item, {
        perView: 1,
        type: 'carousel',
      }).mount();
    });
  }

  const attorneysTabsBlockTabsWrapperMobileSlider =
    '.attorneys-tabs-block__tabs_wrapper_mobile';
  if (ifSelectorExist(attorneysTabsBlockTabsWrapperMobileSlider)) {
    Array.from(getElements(attorneysTabsBlockTabsWrapperMobileSlider)).forEach(
      item => {
        new Glide(item, {
          perView: 3.5,
          gap: 5,
          type: 'slider',
          breakpoints: {
            640: {
              perView: 2.4,
            },
          },
        }).mount();
      }
    );
  }
};
